import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";
import API_BASE_URL from "../../config";
const SHALIGRAM_CATEGORY_SLUG = "shaligram";
const banners = [
  "https://res.cloudinary.com/yi3u1mel/image/upload/v1793373869/1000457612.webp",

  "https://res.cloudinary.com/yi3u1mel/image/upload/v1793373870/1000457614.webp",

  "https://res.cloudinary.com/yi3u1mel/image/upload/v1793373869/1000457613.webp",
];

export default function Shaligram() {
  const [shaligramCategory, setShaligramCategory] =
    useState(null);

  const [subcategories, setSubcategories] =
    useState([]);

  const [activeSubcategory, setActiveSubcategory] =
    useState(null);

  const [products, setProducts] = useState([]);

  const [loadingCategories, setLoadingCategories] =
    useState(true);

  const [loadingProducts, setLoadingProducts] =
    useState(false);
  useEffect(() => {
    const fetchShaligramCategory = async () => {
      try {
        setLoadingCategories(true);

        const result = await getCategories();

        console.log(
          "All Categories:",
          result
        );

        if (!result?.success) {
          setShaligramCategory(null);
          setSubcategories([]);
          return;
        }

        const categories = result?.data || [];

        // Find Shaligram category by slug
        const shaligram = categories.find(
          (category) =>
            category?.slug?.toLowerCase() ===
            SHALIGRAM_CATEGORY_SLUG.toLowerCase()
        );

        console.log(
          "Shaligram Category:",
          shaligram
        );

        if (!shaligram) {
          console.error(
            "Shaligram category not found"
          );

          setShaligramCategory(null);
          setSubcategories([]);

          return;
        }

        setShaligramCategory(shaligram);

        // If subcategories are already included
        if (
          Array.isArray(
            shaligram.subcategories
          )
        ) {
          setSubcategories(
            shaligram.subcategories
          );
        } else {
          // Fetch subcategories separately
          const subResponse = await fetch(
            `${API_BASE_URL}/categories/${shaligram.id}/subcategories`
          );

          const subResult =
            await subResponse.json();

          console.log(
            "Shaligram Subcategories:",
            subResult
          );

          if (subResult?.success) {
            setSubcategories(
              subResult.data || []
            );
          } else {
            setSubcategories([]);
          }
        }
      } catch (error) {
        console.error(
          "Shaligram Category API Error:",
          error
        );

        setShaligramCategory(null);
        setSubcategories([]);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchShaligramCategory();
  }, []);

  const fetchAllProducts = async (
    categoryId
  ) => {
    try {
      if (!categoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: categoryId,
        page: 1,
        limit: 12,
      });

      console.log(
        "All Shaligram Products:",
        result
      );

      if (result?.success) {
        setProducts(
          result?.data?.products || []
        );
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error(
        "Shaligram Products API Error:",
        error
      );

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };
  const fetchProductsBySubcategory = async (
    subcategoryId
  ) => {
    try {
      if (
        !shaligramCategory?.id ||
        !subcategoryId
      ) {
        return;
      }

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: shaligramCategory.id,
        subcategoryId: subcategoryId,
        page: 1,
        limit: 12,
      });

      console.log(
        "Shaligram Products By Subcategory:",
        result
      );

      if (result?.success) {
        setProducts(
          result?.data?.products || []
        );
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error(
        "Shaligram Subcategory Products API Error:",
        error
      );

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };
  useEffect(() => {
    if (shaligramCategory?.id) {
      setActiveSubcategory(null);

      fetchAllProducts(
        shaligramCategory.id
      );
    }
  }, [shaligramCategory]);

  const handleSubcategoryClick = (
    subcategory
  ) => {
    if (!subcategory?.id) return;

    setActiveSubcategory(
      subcategory.id
    );

    fetchProductsBySubcategory(
      subcategory.id
    );
  };

  const handleAllClick = () => {
    if (!shaligramCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(
      shaligramCategory.id
    );
  };


  return (
    <section className="rudraksha-section">
      <div className="container">
        <div className="section-top">

          <h2>
            Buy 100% Shaligram
          </h2>

    
          <div className="tabs">

            {/* ALL SHALIGRAM */}

            <button
              type="button"
              className={
                activeSubcategory === null
                  ? "active"
                  : ""
              }
              onClick={handleAllClick}
              disabled={
                loadingCategories ||
                !shaligramCategory
              }
            >
              All Shaligram
            </button>

            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map(
                (subcategory) => (
                  <button
                    type="button"
                    key={subcategory.id}
                    className={
                      activeSubcategory ===
                      subcategory.id
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleSubcategoryClick(
                        subcategory
                      )
                    }
                  >
                    {subcategory.name}
                  </button>
                )
              )}

          </div>
        </div>

        {/* =================================================
            CONTENT
        ================================================= */}

        <div className="section-content">

          {/* =================================================
              LEFT BANNER
          ================================================= */}

          <div className="left-banner">

            <Swiper
              modules={[Autoplay]}
              loop
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
            >
              {banners.map(
                (image, index) => (
                  <SwiperSlide
                    key={index}
                  >
                    <img
                      src={image}
                      alt="Shaligram"
                    />
                  </SwiperSlide>
                )
              )}
            </Swiper>

          </div>

          {/* =================================================
              RIGHT PRODUCTS
          ================================================= */}

          <div className="right-products">

            {/* LOADING */}

            {loadingCategories ||
            loadingProducts ? (
              <div className="loading">
                <Loader label="Loading Shaligrams..." size={56} />
              </div>
            ) : products.length === 0 ? (

              /* NO PRODUCTS */

              <div className="loading">
                No Shaligram products found
              </div>

            ) : (

              <Swiper
                modules={[
                  Navigation,
                  Autoplay,
                ]}
                navigation
                loop={
                  products.length > 3
                }
                spaceBetween={10}
                slidesPerView={3}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                }}
              >

                {products.map(
                  (product) => (
                    <SwiperSlide
                      key={product.id}
                    >
                      <ProductCard
                        product={product}
                      />
                    </SwiperSlide>
                  )
                )}

              </Swiper>

            )}

          </div>

        </div>

      </div>
    </section>
  );
}


